import { apiClient, unwrapApi } from './http';

/**
 * Service catalog API — /services/*
 */
export async function getServices(params = {}) {
  const { data } = await apiClient.get('/services', { params });
  return unwrapApi(data);
}

export async function getService(id) {
  const { data } = await apiClient.get(`/services/${id}`);
  return unwrapApi(data);
}

export async function createService(payload) {
  const { data } = await apiClient.post('/services', payload);
  return unwrapApi(data);
}

export async function updateService(id, payload) {
  const { data } = await apiClient.put(`/services/${id}`, payload);
  return unwrapApi(data);
}

export async function deleteService(id) {
  const { data } = await apiClient.delete(`/services/${id}`);
  return unwrapApi(data);
}

const servicesService = {
  getServices,
  getService,
  createService,
  updateService,
  deleteService,
};

export default servicesService;
